import React from 'react'
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import AllOrdersFordelivery from "../../components/Delivery/AllOrders/AllOrdersForDelivery";

const HomePage = () => {
  return (
    <div>
        <Header activeHeading={2} />
        <AllOrdersFordelivery />
        <Footer />
    </div>
  )
}

export default HomePage